import { motion } from "framer-motion";
import { Flag, ArrowDown } from "lucide-react";
import { useSiteContent } from "@/hooks/useSiteContent";
import { getBlock } from "@/lib/siteContent";

const MissionFocusCard = () => {
  const { blocks } = useSiteContent("home");
  const eyebrow = getBlock(blocks, "mission_eyebrow", "Welcome");
  const headline = getBlock(
    blocks,
    "mission_headline",
    "Step into a functional ideascape for Alabama.",
  );
  const body = getBlock(
    blocks,
    "mission_body",
    "The Emerging Market is an Alabama public benefit corporation (LLC) and government affairs firm. We build strategies for grassroots organizations and businesses that rarely have a partner in the room. Lobbying, strategic communication, advocacy, research, and economic development — all wired into a living ideascape of bills, grants, partners, and insights you can tour below.",
  );
  return (
    <section className="bg-cream pt-12 md:pt-16">
      <div className="container mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="rounded-[var(--radius)] bg-card border border-border shadow-card p-6 md:p-8"
        >
          <div className="flex items-start gap-4 mb-4 md:mb-5">
            <div className="w-11 h-11 rounded-full bg-primary/10 flex items-center justify-center shrink-0">
              <Flag className="h-5 w-5 text-primary" />
            </div>
            <div>
              <div className="text-primary text-xs font-semibold tracking-[0.2em] uppercase mb-1">
                {eyebrow}
              </div>
              <h2 className="font-display text-2xl md:text-3xl font-bold text-foreground leading-tight">
                {headline}
              </h2>
            </div>
          </div>

          <p className="text-base md:text-lg text-muted-foreground leading-relaxed md:pl-[60px]">
            {body}
          </p>
          <div className="mt-5 md:mt-6 md:pl-[60px] flex items-center gap-2 text-primary text-sm font-semibold">
            <ArrowDown className="h-4 w-4" />
            Tour the ideascape below
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default MissionFocusCard;